<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex @click="printPage()" shrink style="text-align: right"><v-btn dark style="width: 80px; background-color: black;"><v-icon>local_printshop</v-icon></v-btn></v-flex>
        <h1>แบบฟอร์ม</h1>
        <div id="print" style="height: auto">
        <div class="print-form">
        <v-layout>
          <v-flex>
            <v-layout mt-3 style="background-color: #3e7662">
              <v-flex my-8 ml-8 style="text-align: left; font-size: 28px; color: white">
                <div style="font-weight: bold">
                  แบบรายงานเหตุการณ์ไม่พึงประสงค์นอกสถาบัน SUSAR / DMC / DSMB
                </div>
                <div style="font-size: 18px">
                  off-campus adverse event reporting form
                </div>
              </v-flex>
              <v-flex ml-8 pt-8 pr-8 style="
                  text-align: right;
                  font-weight: bold;
                  font-size: 13px;
                  color: white;
                ">
                <span>RFXX_2023_00</span>
              </v-flex>
            </v-layout>
            <!-- blog1 -->
            <v-card class="py-12" style="padding-right: 80px; padding-left: 80px">
              <v-layout>
                <v-flex>
                  <!-- row 1 -->
                  <!-- แก้ไขความยาว textfield -->
                  <v-layout>
                    <v-flex>
                      <textfield-form label="รหัสโครงร่างการวิจัย" readonly :model="form.researchCode"
                        @update-data="updateData('researchCode', $event)">
                      </textfield-form>
                    </v-flex>
                    <v-flex ml-3 style="visibility: hidden" disabled>
                      <textfield-form label="นามสกุล" readonly></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout ml-13>
                    <v-flex>
                      <textfield-form :model="form.firstName" @update-data="updateData('firstName', $event)"
                        label="ชื่อผู้วิจัยหลัก" readonly></textfield-form>
                    </v-flex>
                    <v-flex ml-3>
                      <textfield-form :model="form.lastName" @update-data="updateData('lastName', $event)" label="นามสกุล"
                        readonly></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex>
                      <textfield-form :model="form.researchName" hide-detail
                        @update-data="updateData('researchName', $event)" label="ชื่อโครงการวิจัย(ไทย)" readonly>
                      </textfield-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <!-- blog 2 -->
            <v-layout mt-12 style="background-color: #3e7662">
              <v-flex pl-6 my-5 ml-8 style="font-size: 18px; color: white">
                <span>รายละเอียดงาน</span>
              </v-flex>
            </v-layout>
            <!-- row1 -->
            <v-layout py-12 style="
                background-color: white;
                padding-left: 80px;
                padding-right: 80px;
              ">
              <v-flex>
                <div v-for="(input, k) in newRow" :key="k">
                  <v-layout :style="[
                    k == 1
                      ? { 'margin-top': '50px' }
                      : { 'margin-top': '0px' },
                  ]">
                    <span style="font-weight: bold; padding-top: 19px">วันที่ผู้วิจัยรายงาน</span>
                    <v-col cols="2" class="text-end text-field-center">
                      <DateInputForm :model="input.startDate" @update-data="updateDataMultiRow('startDate', $event, k)"
                        style="font-weight: bold"></DateInputForm>
                    </v-col>
                    <span style="font-weight: bold; padding-top: 19px">วันที่รายงานถึงสำนักงานพิจารณาโครงการวิจัย
                      พบ.</span>
                    <v-col cols="2" class="text-end text-field-center">
                      <DateInputForm :model="input.startReport"
                        @update-data="updateDataMultiRow('startReport', $event, k)" style="font-weight: bold">
                      </DateInputForm>
                    </v-col>
                    <v-flex shrink style="text-align: left">
                      <v-btn v-if="k === 0" dark @click="add()" style="
                          margin-top: 14px;
                          width: 80px;
                          background-color: #3e7662;
                          margin-left: 340px;
                        ">
                        <v-icon>add</v-icon>
                        <span class="font-weight-bold">เพิ่ม</span>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-flex ml-8 my-5 style="text-align: left; font-weight: bold">
                    <span>SUSAR / REPORT</span>
                    <v-icon :disabled="newRow.length <= 1" color="#CC3D45" class="clear-card" @click="remove(k)">
                      clear
                    </v-icon>
                  </v-flex>
                  <v-layou>
                    <v-flex style="padding-left: 32px; padding-right: 32px">
                      <textarea-form :rows="10" :model="input.reportsusar"
                        @update-data="updateDataMultiRow('reportsusar', $event, k)"></textarea-form>
                    </v-flex>
                  </v-layou>
                  <v-layout px-12>
                    <v-flex shrink pt-2 pr-4 style="text-align: left" class="justify-end d-flex">
                      <span style="font-weight: bold; font-size: 16px">ไฟล์</span>
                    </v-flex>

                    <v-flex xs3 class="d-flex">
                      <v-file-input accept=".pdf" prepend-icon="" outlined dense id="file" placeholder="Choose file"
                        color="#3E7662" item-color="#3E7662" hide-details :model="input.file"
                        @change="updateDynamicFileData('file',k,$event)"></v-file-input>
                    </v-flex>
                    <v-flex shrink pl-4 style="text-align: left">
                      <v-btn @click="chooseFiles('file')" color="#3E7662" dark>
                        <v-icon class="pr-3">cloud_download</v-icon>
                        <span>Upload</span>
                      </v-btn>
                    </v-flex>
                     <v-flex v-if="input.filePath">
                              <a
                                :href="input.filePath"
                                target="_blank"
                                style="color: #3e7662; text-align: center"
                                class="link-hover"
                              >
                                <p>ไฟล์ที่อัพโหลด: {{ input.file }}</p>
                              </a>
                            </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
            <!-- blog3 -->
            <v-layout mt-12 style="background-color: #3e7662">
              <v-layout py-12 style="
                  background-color: white;
                  padding-left: 80px;
                  padding-right: 80px;
                ">
                <v-flex>
                  <v-flex ml-8 my-5 style="text-align: left; font-weight: bold">
                    <span>ข้อเสนอแนะ</span>
                  </v-flex>
                  <v-layout>
                    <v-flex style="padding-left: 32px; padding-right: 32px">
                      <textarea-form :rows="5" :model="form.suggestion"
                        @update-data="updateData('suggestion', $event)"></textarea-form>
                    </v-flex>
                  </v-layout>

                  <v-layout style="margin-top: 50px;">
                    <v-flex xs6>
                      <v-layout>
                        <v-flex xs3 mt-4 class="justify-start font-weight-bold d-flex align-center">
                          <span style="margin-left: 95px">ผู้ประเมิน</span>
                        </v-flex>
                        <v-flex xs6 class="text-start text-field-center">
                          <v-text-field :readonly="$route.query.read == 1 ? true : false" hide-details
                            v-model="form.signature" color="#3E7662" append-icon="edit" />
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs3></v-flex>
                        <v-flex xs6 class=" text-field-center">
                          <v-layout>
                            <v-flex mr-2 mt-5 shrink class="d-flex align-center">
                              <span>(</span>
                            </v-flex>
                            <v-flex>
                              <v-text-field :readonly="$route.query.read == 1 ? true : false
                                " hide-details v-model="form.signature" color="#3E7662" />
                            </v-flex>
                            <v-flex ml-2 mt-5 shrink class="d-flex align-center">
                              <span>)</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-flex>
                    <!--                                        <v-spacer></v-spacer>-->
                    <v-flex xs6 class="text-end">
                      <v-layout>
                        <v-spacer></v-spacer>
                        <v-flex xs2 mr-2 class="text-end font-weight-bold d-flex align-center">
                          <span>วันที่ประเมินงาน</span>
                        </v-flex>
                        <v-flex style="margin-right: 150px" xs6 class="text-end text-field-center">
                          <DateInputForm hide-detail :model="dateChange"
                            />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-layout pt-16 justify-space-between="">
                    <v-flex d-flex justify-start>
                      <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>
            <!-- button -->
            <v-layout mt-6>
              <v-flex mb-12 style="text-align: right">
                <v-layout>
                  <v-flex>
                    <v-btn style="color: #3e7662" depressed @click="$router.go(-1)" color="#ffffff">ย้อนกลับ</v-btn>
                    <v-btn depressed dark class="mx-4" color="#3E7662" @click="saveDraft">
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <span>บันทึกข้อมูลและส่งการประเมิน</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        </div>
        </div>
      </v-flex>
        <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-pageAndLine="fullpageAndLine">
        </loading>

    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "@/components/input/TextfieldForm";
import TextareaForm from "@/components/input/TextareaForm";
import DateInputForm from "@/components/input/DateInputForm";
import TextfieldFormAppend from "@/components/input/TextfieldFormAppend";
import FileInputForm from "@/components/input/FileInputForm";
import Swal from 'sweetalert2';
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";
export default {
  name: "FormRFSusar",
  components: {
    TextfieldFormAppend,
    TextfieldForm,
    TextareaForm,
    DateInputForm,
    Loading,
    FileInputForm,
  },
  data: () => ({
    isLoading: false,
      fullpageAndLine: true,
    form: {
      date:"",
      researchCode: "",
      researchName: "",
      firstName: "",
      lastName: "",
      signature: "",
      suggestion: "",
    },
    newRow: [
      {
        startDate: "",
        startReport: "",
        reportsusar: "",
        file: "",
      },
    ],
    isSubmit: false,
    dateChange: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.form.researchCode = this.$route.query.researchCode;
    this.form.researchName = this.$route.query.researchName;
    this.form.firstName = this.$route.query.firstName;
    this.form.lastName = this.$route.query.lastName;
    this.form.signature = this.user.thName;

    this.updateDate("date", { date: new Date().toISOString().substr(0, 10) });
    this.getROSusar();
  },
  methods: {
    updateDate(name , val){
      if (name === "date") {
        this.form.date = val.date;
        this.dateChange = this.changeDate(val.date);
      }
    },
     async printPage() {
      this.printMode = true
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
          "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
          element.innerHTML = '✓' + element.innerHTML
        })
      await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
          element.innerHTML = '✓ ' + element.innerHTML
        })
      var node = document.getElementById("print");
      var self = this;
      domtoimage
          .toPng(node)
          .then( async function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            var page = self.imageToPrint(img);

            var pageLink = "about:blank";
            var pwa = window.open(pageLink, "_new");
            pwa.document.open();
            pwa.document.write(page);
            pwa.document.close();
            self.printMode = false
            await document.querySelectorAll("button").forEach(function (element) {
              element.style.display = 'unset'
            });
            await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
              element.innerHTML = element.innerHTML.replace('✓', '')
            })
            await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
              element.innerHTML = element.innerHTML.replace('✓ ', '')
            })
            await document.querySelectorAll(".v-icon").forEach(function (element) {
              element.style.display = 'unset'
            });
            document
                .getElementsByClassName("print-form")[0]
                .removeAttribute("style");
          })
          .catch(function (error) {
            Swal.fire({
              title: "กรุณาเปิดการอนุญาต Pop Up!",
              description: "",
              icon: "error",
              confirmButtonColor: "#3E7662",
              cancelButtonColor: "rgb(189, 189, 189)",
              confirmButtonText: "ตกลง",
            }).then(async function() {

              await document.querySelectorAll("button").forEach(function (element) {
                element.style.display = 'unset'
              });
              await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
                element.innerHTML = element.innerHTML.replace('✓', '')
              })
              await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
                element.innerHTML = element.innerHTML.replace('✓ ', '')
              })
              await document.querySelectorAll(".v-icon").forEach(function (element) {
                element.style.display = 'unset'
              });
              document
                  .getElementsByClassName("print-form")[0]
                  .removeAttribute("style");
            })
          });
    },
    imageToPrint(source) {
      return (
          "<html><body onload='window.print()'><style>@media print {\n" +
          "  @page { margin: 0; }\n" +
          "  html, body {\n" +
          "    margin: 0;\n" +
          "    width: 210mm;\n" +
          "    height: 297mm;\n" +
          "  }\n" +
          "  img {\n" +
          "    margin-top: 10mm;\n" +
          "    margin-left: 20mm;\n" +
          "    width: 170mm;\n" +
          // "    height: 297mm;\n" +
          "  }\n" +
          "}</style>" +
          source.outerHTML +
          "</body></html>"
      );
    },
    add() {
      this.newRow.push({
        startDate: "",
        startReport: "",
        reportsusar: "",
        file: "",
      });
    },
    remove(index) {
      this.newRow = this.newRow.filter((item, i) => i !== index);
    },
    updateDataMultiRow(name, val, index) {
      if (name === "startDate") {
        this.newRow[index].startDate = val.date;
        this.newRow[index].startDate = this.changeDate(val.date);
      }
      if (name === "startReport") {
        this.newRow[index].startReport = val.date;
        this.newRow[index].startReport = this.changeDate(val.date);
      }
      if (name === "reportsusar") {
        this.newRow[index][name] = val;
      }
    },
    updateDynamicFileData(type, index, value) {
      if (type === "file") {
        this.$store
          .dispatch("Common/uploadPdf", { form: "rf-susar", file: e })
          .then((res) => {
            console.log("filename: ", res.fileName);
            this.newRow[index].file = res.fileName;
          })
          .catch((error) => {});
      }
    },
    // onUpload(name, e , index) {
    //   this.newRow[index].file = e.name;
    //   this.$store.dispatch("Common/uploadPdf", { form: "rfsusar", file: e })
    //     .then((res) => {
    //       console.log(res);
    //       this.newRow[index].file = res.fileName;
    //     })
    //     .catch((error) => {  });
    // },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    chooseFiles: function () {
      document.getElementById("file").click();
    },
    updateData(name, val) {
      this.form[name] = val;
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          console.log('form', this.form);
          this.isLoading = true;
          this.form["newRow"] = this.newRow;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveROSusar", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              // this.viewData();
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    saveDraft() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          console.log('form', this.form);
          this.isLoading = true;
          this.form["newRow"] = this.newRow;
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;
          this.$store
            .dispatch("FormRO/saveDraftROSusar", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              // this.viewData();
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    getROSusar() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getROSusar", {
          researchID: this.$route.query.id,
          rfID: this.$route.query.rfID,
        })
        .then((res) => {
          if (res !== "don't have FormRFSusar yet") {
            console.log("pass",res);
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.newRow = res.report ?? [];
            this.form.suggestion = res.suggestion;
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
</style>
